import { routeName } from '@/constants/routeName';
import { parseQueryToken, hubSelectorDisabler, } from '@/router-middleware';
import MapControl from '@/views/MapControl/index.vue';
export default {
    path: '/map-control',
    name: routeName.MAP_CONTROL,
    component: MapControl,
    meta: {
        middleware: [
            hubSelectorDisabler,
            parseQueryToken,
        ],
    },
};
